import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/navbar/Navbar';
import { AuthProvider } from './context/AuthContext';
import Footer from './components/Footer';
import Home from './pages/Home';
// Pricing pages disabled until a payment gateway is available
// import Pricing from './pages/Pricing';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import GetQuote from './pages/GetQuote';
import ChooseMovers from './pages/ChooseMovers';
import QuoteSuccess from './pages/QuoteSuccess';
import QuotesDashboard from './pages/QuotesDashboard';
import RegisterMover from './pages/RegisterMover';
import SignInMover from './pages/SignInMover';
import RegistrationSuccess from './pages/RegistrationSuccess';
import UserDashboard from './pages/UserDashboard';
import ViewMoversForQuote from './pages/ViewMoversForQuote';
import TruckerProfile from './pages/TruckerProfile';
import MoverDetails from './pages/MoverDetails';
import MovingTips from './pages/MovingTips';
// import PricingPlans from './pages/PricingPlans'; // disabled — no payment gateway
import SuccessStories from './pages/SuccessStories';
import Resources from './pages/Resources';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import SignInUser from './pages/SignInUser';
import AdminLogin from './pages/AdminLogin';
import ResetPassword from './pages/ResetPassword';
import CustomerGuide from './pages/CustomerGuide';
import MoversList from './pages/MoversList';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/admin/ProtectedRoute';
import ProtectedMoverRoute from './components/common/ProtectedMoverRoute';
import ProtectedUserRoute from './components/common/ProtectedUserRoute';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <AuthProvider>
          <div className="min-h-screen flex flex-col">
            <Toaster
              position="top-right"
              containerStyle={{ top: 80 }}
              toastOptions={{
                duration: 4000,
                style: { fontFamily: 'inherit', fontSize: '14px', borderRadius: '10px', padding: '12px 16px' },
                success: { iconTheme: { primary: '#22c55e', secondary: '#fff' } },
                error: { iconTheme: { primary: '#ef4444', secondary: '#fff' }, duration: 5000 },
              }}
            />
            <Navbar />
            <main className="flex-grow">
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/quote" element={<GetQuote />} />
              <Route path="/choose-movers" element={<ChooseMovers />} />
              <Route path="/quote-success" element={<QuoteSuccess />} />
              <Route path="/quotes" element={<QuotesDashboard />} />
              {/* Pricing pages disabled until a payment gateway is available */}
              {/* <Route path="/pricing" element={<Pricing />} /> */}
              <Route path="/dashboard" element={<ProtectedMoverRoute><Dashboard /></ProtectedMoverRoute>} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              <Route path="/register" element={<RegisterMover />} />
              <Route path="/signin-mover" element={<SignInMover />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/mover-dashboard" element={<ProtectedMoverRoute><Dashboard /></ProtectedMoverRoute>} />
              <Route path="/movers" element={<MoversList />} />
              <Route path="/registration-success" element={<RegistrationSuccess />} />
              <Route path="/user" element={<ProtectedUserRoute><UserDashboard /></ProtectedUserRoute>} />
              <Route path="/user/view-movers" element={<ProtectedUserRoute><ViewMoversForQuote /></ProtectedUserRoute>} />
              <Route path="/movers/:slug" element={<MoverDetails />} />
              <Route path="/truckers/:id" element={<TruckerProfile />} />
              <Route path="/moving-tips" element={<MovingTips />} />
              <Route path="/guide" element={<CustomerGuide />} />
              {/* <Route path="/pricing-plans" element={<PricingPlans />} /> */}
              <Route path="/success-stories" element={<SuccessStories />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/signin-user" element={<SignInUser />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
